import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthState, Usuario, LoginForm } from '../types';
import api from '../utils/api';

interface AuthStore extends AuthState {
  login: (credentials: LoginForm) => Promise<boolean>;
  logout: () => void;
  setUser: (user: Usuario) => void;
  setToken: (token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      login: async (credentials: LoginForm) => {
        set({ isLoading: true });
        try {
          const response = await api.post('/auth/login', credentials);
          const { token, user } = response.data;

          if (user.funcao !== 'motorista') {
            throw new Error('Acesso negado. Apenas motoristas podem usar esta interface.');
          }

          set({
            user,
            token,
            isAuthenticated: true,
            isLoading: false,
          });

          localStorage.setItem('motorista_token', token);
          localStorage.setItem('motorista_user', JSON.stringify(user));

          return true;
        } catch (error: any) {
          set({ isLoading: false });
          throw new Error(error.response?.data?.error || 'Erro ao fazer login');
        }
      },

      logout: () => {
        get().clearAuth();
        window.location.href = '/login';
      },

      setUser: (user: Usuario) => {
        set({ user, isAuthenticated: true });
      },

      setToken: (token: string) => {
        set({ token, isAuthenticated: true });
      },

      clearAuth: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false,
        });
        localStorage.removeItem('motorista_token');
        localStorage.removeItem('motorista_user');
      },
    }),
    {
      name: 'motorista-auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);



